import { Box, LinearProgress } from '@mui/material';
import React from 'react';

interface ProgressBarProps {
  /** Current step number (1-based) */
  current: number | null;
  /** Total number of steps */
  total: number;
}

/**
 * ProgressBar - Visual progress indicator for the installation guide
 * 
 * Shows a thin horizontal bar with orange/gold fill indicating
 * progress through the wizard steps.
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  if (current === null) {
    return null;
  }

  // Calculate progress percentage (0-100)
  const progressValue = Math.round((current / total) * 100);

  return (
    <Box sx={{ width: '100%', px: 0 }}>
      <LinearProgress
        variant="determinate"
        value={progressValue}
        sx={{
          height: 4,
          bgcolor: '#e0e0e0',
          '& .MuiLinearProgress-bar': {
            bgcolor: '#F5A623', // Orange/gold color matching Storyline
            borderRadius: 0,
          },
        }}
      />
    </Box>
  );
};
